import { Composition } from 'remotion';

import { MaterialVideoRemotionPreview } from '../components/forms/material-video-remotion-preview';
import {
  MATERIAL_VIDEO_LAYOUT,
  MATERIAL_VIDEO_RENDER_CONFIG
} from '../lib/material-video-preview';
import {
  MATERIAL_VIDEO_REMOTION_COMPOSITION_ID,
  type MaterialVideoRenderSource,
  buildMaterialVideoRenderProps
} from '../lib/material-video-render';

const defaultMaterial = {
  title: '',
  media_url: '',
  audio_url: '',
  media_kind: 'video',
  total_duration: 1,
  timeline: { groups: [] }
} satisfies MaterialVideoRenderSource;

export const RemotionRoot = () => {
  const defaultProps = buildMaterialVideoRenderProps(defaultMaterial);

  return (
    <Composition
      calculateMetadata={({ props }) => {
        const inputProps =
          props && typeof props === 'object'
            ? (props as typeof defaultProps)
            : defaultProps;

        return {
          durationInFrames: Math.max(
            1,
            Math.ceil(
              Math.max(inputProps.totalDuration || 0.1, 0.1) *
                MATERIAL_VIDEO_RENDER_CONFIG.fps
            ) + 1
          )
        };
      }}
      id={MATERIAL_VIDEO_REMOTION_COMPOSITION_ID}
      component={MaterialVideoRemotionPreview}
      defaultProps={defaultProps}
      durationInFrames={Math.max(
        1,
        Math.ceil(defaultProps.totalDuration * MATERIAL_VIDEO_RENDER_CONFIG.fps) + 1
      )}
      fps={MATERIAL_VIDEO_RENDER_CONFIG.fps}
      height={MATERIAL_VIDEO_LAYOUT.compositionHeight}
      width={MATERIAL_VIDEO_LAYOUT.compositionWidth}
    />
  );
};
